/** UI-Internal Notification Toast (for NotificationInternalToast) */
export const NotificationVariants = {
  Default: 'DEFAULT',
  Primary: 'PRIMARY',
  Positive: 'POSITIVE',
  Negative: 'NEGATIVE',
  Warning: 'WARNING',
  Attention: 'ATTENTION',
} as const;
export type NotificationVariants = (typeof NotificationVariants)[keyof typeof NotificationVariants];

export type NotificationSizes = 'Small' | 'Default';
